<template>
  <div>
    <el-dialog
      top="6vh"
      width="800px"
      center
      title="合并暂存支付订单"
      :close-on-click-modal="false"
      :visible="visible"
      @close="tempPayReceiptDialogCancel()"
    >
      <el-alert type="warning" :closable="false">
        此银行卡存在以下已收到入款但没有匹配到实际订单的暂存订单，此暂存订单已经扣了卡主积分，请认真核对
        金额/时间/收款人
        信息，如果是和掉单情况一致请使用【合并】按钮操作。否则卡主可能会被重复扣除积分，导致需要后续处理。
      </el-alert>

      <el-table
        stripe
        v-loading="tableLoading"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-spinner="el-icon-loading"
        :data="dataList"
      >
        <el-table-column label="金额">
          <template slot-scope="scope">
            {{ formatNumberWithCommasAndDecimalSeparator(scope.row.amount, 2) }}
          </template>
        </el-table-column>
        <el-table-column label="付款人">
          <template slot-scope="scope">
            {{ scope.row.transPayName || "-" }}
          </template>
        </el-table-column>
        <el-table-column width="153" label="收款时间">
          <template slot-scope="scope">
            {{ scope.row.transPayedTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column width="153" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createdTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column align="center" width="190">
          <template slot-scope="scope">
            <el-button
              :loading="scope.row.refundStatus !== 0"
              @click="forceRefund(scope.row)"
              size="small"
              type="danger"
              >直接退款</el-button
            >
            <el-button
              :disabled="scope.row.refundStatus !== 0"
              size="small"
              type="success"
              @click="tempPayReceiptMerge(scope.row)"
            >
              合并
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer">
        <el-button size="small" @click="tempPayReceiptDialogCancel()">
          不合并
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * @props
 * {
 *  amount, // 金额 (选填)
 *  bankNo, // 银行卡号
 * }
 *
 * @return
 * {
 *  tempOrderId, // 暂存订单号
 *  isCombinedTempOrder: true, // 是否为结合暂存订单
 *  mergePayName, // 付款人姓名
 *  mergeAmount, // 金额
 * }
 */
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import {
  getTempPayReceipts,
  enforcePayOrderRefund, // 支付订单直接退款
} from "@/api/order";

export default {
  mixins: [mainCommon],
  props: {
    tempPayReceiptMergeDialogObj: {
      required: true,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      dataList: [],
      visible: false,
      tableLoading: false,
      refundCheckerTimer: null, // 退款中订单检查计时器
    };
  },
  watch: {
    tempPayReceiptMergeDialogObj(row) {
      if (row && row.bankNo) {
        // 必须至少有 "银行卡号" 来取得 "暂存支付订单"
        this.getTempPayReceipts();
      }
    },
  },
  methods: {
    // 直接退款
    forceRefund(row) {
      this.$confirm("确定直接退款？", varCommon.message.warning, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "warning",
      })
        .then(() => {
          row.refundButtonLoading = true;
          enforcePayOrderRefund(row.orderId).then(() => {
            this.$notify.success("操作成功");
            this.getTempPayReceipts();
            this.refundOrdersChecker();
          });
        })
        .catch(() => {});
    },
    tempPayReceiptMerge(row) {
      this.$confirm("确定合并吗？", row.transPayName, {
        confirmButtonText: varCommon.message.confirm,
        cancelButtonText: varCommon.message.cancel,
        type: "warning",
      })
        .then(() => {
          this.$emit("update:temp-pay-receipt-merge-dialog-obj", {
            tempOrderId: row.orderId,
            isCombinedTempOrder: true,
            mergePayName: row.transPayName,
            mergeAmount: row.amount,
            reloadList: true,
          });
          this.visible = false;
        })
        .catch(() => {});
    },
    tempPayReceiptDialogCancel() {
      this.visible = false;
      this.dataList = [];
      this.$emit("update:temp-pay-receipt-merge-dialog-obj", {
        reloadList: true,
      });
    },
    // 检查列表内是否还有正在退款的暂存订单，有则刷新一次列表
    refundOrdersChecker() {
      if (!this.refundCheckerTimer) {
        this.refundCheckerTimer = setInterval(() => {
          if (this.dataList.some((res) => res.refundStatus !== 0)) {
            this.getTempPayReceipts();
          } else {
            clearInterval(this.refundCheckerTimer);
            this.refundCheckerTimer = null;
          }
        }, 5000);
      }
    },
    getTempPayReceipts() {
      this.tableLoading = true;
      getTempPayReceipts({
        amount: this.tempPayReceiptMergeDialogObj.amount,
        bankNo: this.tempPayReceiptMergeDialogObj.bankNo,
      })
        .then((res) => {
          this.dataList = res.data.map((r) => {
            r.refundButtonLoading = r.refundStatus !== 0; // 若该笔仍在处理退款，按钮 loading 不给点
            return r;
          });

          // 若有找到暂存支付订单，开启弹框
          if (res.data.length > 0) {
            this.visible = true;
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.refundCheckerTimer); // 清除定时器
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/TempPayReceiptMerge.vue